import React from 'react';

export default function ActivityLog() {
	const data = [
		{ date: '27/10/2025', time: '07:28PM', text: 'Lorem ipsum dolor sit amet consectetur.' },
		{ date: '27/10/2025', time: '07:28PM', text: 'Lorem ipsum dolor sit amet consectetur.' },
		{ date: '27/10/2025', time: '07:28PM', text: 'Lorem ipsum dolor sit amet consectetur.' },
		{ date: '27/10/2025', time: '07:28PM', text: 'Lorem ipsum dolor sit amet consectetur.' },
		{ date: '27/10/2025', time: '07:28PM', text: 'Lorem ipsum dolor sit amet consectetur.' },
		{ date: '27/10/2025', time: '07:28PM', text: 'Lorem ipsum dolor sit amet consectetur.' },
	];
	return (
		<div className="container py-5">
			<div className="timeline-line"></div>

			{data.map((item, index) => (
				<div
					className="row timeline-item"
					key={index}
				>
					{/* LEFT DATE */}
					<div className="col-3 text-end pe-4 timeline-date">
						<div>{item.date}</div>
						<div>{item.time}</div>
					</div>

					{/* DOT */}
					<div className="col-1 position-relative d-flex justify-content-center">
						<div className="timeline-dot"></div>
					</div>

					{/* RIGHT BOX */}
					<div className="col-7">
						<div className="timeline-box shadow-sm">{item.text}</div>
					</div>
				</div>
			))}
		</div>
	);
}
